import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbModalStack } from '@ng-bootstrap/ng-bootstrap/modal/modal-stack';
import { FormGroup } from '@angular/forms';
import { QuestionElement } from '../question-base';

@Component({
  selector: 'app-modal-content',
  templateUrl: './modal-content.component.html',
  styleUrls: ['./modal-content.component.css']
})
export class ModalContentComponent {

  @Input() public subQuestions: Array<QuestionElement> = [];;
  @Input() public form: FormGroup = null;
  
  constructor(
    private modalCtrl: NgbActiveModal
  ){
    
  }
  
  public back(){
    this.modalCtrl.close();
  }
    
  public save(){
    this.modalCtrl.close(234253);
  }
  
}



// WEBPACK FOOTER //
// ./src/app/modal-content/modal-content.component.ts